import React, { useState, useEffect } from 'react'
import CarouselComponent from '@flatsy/core/Carousel/'
import clsx from 'clsx'
import { useStyles } from './Styles'
import { ICarouselAsset } from './Type'

const Carousel = ({ asset, size, noBorderRadius }: ICarouselAsset): React.ReactElement => {
  const classes = useStyles()
  const [slides, setSlides] = useState(asset?.img_urls || [])
  useEffect(() => {
    const findThumbnail = () => {
      if (asset) {
        const index = asset.img_urls.findIndex((element) => element === asset.thumbnail)
        if ((index || index === 0) && index !== -1) {
          const temporarySlides = [...asset.img_urls]
          temporarySlides.splice(index, 1)
          setSlides([asset.img_urls[index], ...temporarySlides])
        }
      }
    }
    if (asset && asset.thumbnail && asset.thumbnail !== '') {
      findThumbnail()
    } else if (asset?.img_urls && asset?.img_urls.length) {
      setSlides([...asset?.img_urls])
    }
  }, [asset])

  if (slides.length === 0) {
    return <></>
  }

  return (
    <div
      className={clsx(
        classes.container,
        size === 'large' && classes.containerLarge,
        size === 'small' && classes.containerSmall
      )}
    >
      <CarouselComponent id="asset-image" slides={slides} noBorderRadius={noBorderRadius} />
    </div>
  )
}

export default Carousel
